import tags from './tags';
import factory from './factory';
import type { HTML } from './contracts';

const Html: HTML = tags.reduce((store, tag) => ({ ...store, [tag]: factory(tag) }), {} as HTML);

export default Html;
